// extracted by mini-css-extract-plugin
module.exports = {"ecom-header":"E9Z_Ej","ecomHeader":"E9Z_Ej"};